/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Too_FewInputs */

const en_us2_profile_editors_too_few = /** @type {(inputs: Profile_Editors_Too_FewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick at least two days.`)
};

const pt_br2_profile_editors_too_few = /** @type {(inputs: Profile_Editors_Too_FewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha pelo menos dois dias.`)
};

const es_419_profile_editors_too_few = /** @type {(inputs: Profile_Editors_Too_FewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige al menos dos días.`)
};

const pt_pt2_profile_editors_too_few = /** @type {(inputs: Profile_Editors_Too_FewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhe pelo menos dois dias.`)
};

const fr_fr2_profile_editors_too_few = /** @type {(inputs: Profile_Editors_Too_FewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisis au moins deux jours.`)
};

const de_de2_profile_editors_too_few = /** @type {(inputs: Profile_Editors_Too_FewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähl mindestens zwei Tage.`)
};

const it_it2_profile_editors_too_few = /** @type {(inputs: Profile_Editors_Too_FewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli almeno due giorni.`)
};

/**
* | output |
* | --- |
* | "Pick at least two days." |
*
* @param {Profile_Editors_Too_FewInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_too_few = /** @type {((inputs?: Profile_Editors_Too_FewInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Too_FewInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_too_few(inputs)
	if (locale === "es-419") return es_419_profile_editors_too_few(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_too_few(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_too_few(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_too_few(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_too_few(inputs)
	return en_us2_profile_editors_too_few(inputs)
});
export { profile_editors_too_few as "profile-editors.too_few" }